export enum SvgIcon {
  BlueCheck = 'blue-check',
  Bus = 'bus',
  Cap = 'school',
  ChevronRight = 'chevron-right',
  ChevronUp = 'chevron-up',
  ChevronDown = 'chevron-down',
  CircleSuccess = 'circle-success',
  ClipboardList = 'clipboard-list',
  ClipboardUsers = 'clipboard-users',
  CommunicationTemplateAlertBanner = 'communication-template-alert-banner',
  CommunicationTemplateEmail = 'communication-template-email',
  Copy = 'copy',
  Document = 'document',
  Edit = 'edit',
  EmailNotification = 'email-notification',
  EmailTemplate = 'email-template',
  EmailUsers = 'email-users',
  ErrorCircleXMark = 'error-circle-xmark',
  ErrorRed = 'error-red',
  EyeView = 'eye-view',
  FloppyDisk = 'floppy-disk',
  FooterPreview = 'footer-preview',
  Giving = 'giving',
  HandMoney = 'hand-money',
  HourglassClock = 'hourglass-clock',
  Household = 'household',
  InfoBlue = 'info-blue',
  isNotPrimary = 'is-not-primary',
  isPrimary = 'is-primary',
  Lightbulb = 'lightbulb',
  Messages = 'messages',
  Messaging = 'messaging',
  Notes = 'notes',
  PaperClip = 'paper-clip',
  SuccessGreen = 'success-green',
  Therapy = 'therapy',
  Transportation = 'transportation',
  TrashCan = 'trash-can',
  Tutor = 'tutor',
  Tutoring = 'tutoring',
  Users = 'users',
  WarningBlack = 'warning-black'
}
